// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MobileUseCases_wrapper__bmnO_","card":"MobileUseCases_card__MF2HW","title":"MobileUseCases_title__TTUKg"};